import { render, staticRenderFns } from "./cardCategory.vue?vue&type=template&id=f021aef6&scoped=true&"
import script from "./cardCategory.vue?vue&type=script&lang=js&"
export * from "./cardCategory.vue?vue&type=script&lang=js&"
import style1 from "./cardCategory.vue?vue&type=style&index=1&id=f021aef6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f021aef6",
  null
  
)

export default component.exports